import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Form from 'react-bootstrap/esm/Form';
import Row from 'react-bootstrap/esm/Row';

export default function ProductSampleFeatures(props) {
  const { features } = props;

  return (
    <div>
      <ListGroup>
        {features
          .filter((f) => !f.deleted)
          .map((f, i) => (
            <ListGroup.Item key={i}>
              <Row style={{ padding: '0px' }}>
                <Col xs={5} style={{ padding: '1px' }}>
                  <Form.Control
                    placeholder="Çeşit Adı"
                    value={f.name}
                    onChange={(e) => {
                      props.productFeaturesChangeHandler(e, f._id, 'name', i);
                    }}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Lutfen çeşit adı alanini bos birakmayiniz
                  </Form.Control.Feedback>
                </Col>

                <Col xs={2} style={{ padding: '1px' }}>
                  <Button
                    variant="light"
                    className="text-danger"
                    onClick={(e) => {
                      props.productFeaturesDeleteHandler(f._id, i);
                    }}
                  >
                    <i className="fas fa-trash"></i>
                  </Button>
                </Col>
              </Row>
            </ListGroup.Item>
          ))}
      </ListGroup>
    </div>
  );
}
